import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Carousel } from '@trendyol-js/react-carousel';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { Tooltip } from 'reactstrap';
import { DateTime } from 'luxon';
import $ from 'jquery'

import { 
    serviceMap, 
    OVERRIDE_ID_GA, OVERRIDE_ID_FB, OVERRIDE_ID_FB_PAGE, OVERRIDE_ID_GMB, OVERRIDE_ID_BING, OVERRIDE_ID_LINKEDIN, OVERRIDE_ID_LINKEDIN_ORG, OVERRIDE_ID_UA_TO_GA4, OVERRIDE_ID_GSC 
} from '../../../utils/common';
import { deleteSiteService, updateSite } from '../../../utils/Organizations';

import ServiceCard from './ServiceCard';

import { appendModel } from '../../../../features/site/siteSlice';
import { deleteMetricSessionStorage } from '../../../../features/metric/metricSlice';

function Base(props){
    const dispatch = useDispatch()
    
    const [chosenService, setChosenService] = useState(serviceMap.ga)
    const [overrideAccounts, setOverrideAccounts] = useState({})
    const [pulse, setPulse] = useState(false)

    const history = useHistory()

    const isAdmin = useSelector(state => state.session.isAdmin)
    const token = useSelector(state => state.session.token)
    const model = useSelector(state => state.site.model)
    const oauthTokens = useSelector(state => state.session.oauthTokens)
    const disableGA4Override = useSelector(state => state.session.disableGA4Override)
    const ga4MetricDateOverride = useSelector(state => state.session.ga4MetricDateOverride)

    useEffect(() => {
        const index = Object.values(serviceMap).findIndex(s => s.key === props.initialChosenService.key)

        const width = $(".translate-custom div[data-testid]").width()

        const calc = width / Object.keys(serviceMap).length

        setChosenService(props.initialChosenService)

        const style = `translateX(${(index * calc * -1).toFixed(0)+"px"})`

        $(".translate-custom div[data-testid]").css("transform", style)
    }, [props.initialChosenService])

    useEffect(() => {
        const overrideAccount = {}
        if(sessionStorage.getItem(OVERRIDE_ID_GA)){
            overrideAccount['ga'] = true
        }

        if(sessionStorage.getItem(OVERRIDE_ID_UA_TO_GA4)){
            overrideAccount['ga4'] = true
        }
    
        if(sessionStorage.getItem(OVERRIDE_ID_GMB)){
            overrideAccount['gmb'] = true
        }
        
        if(sessionStorage.getItem(OVERRIDE_ID_FB)){
            overrideAccount['fb'] = true
        }
        
        if(sessionStorage.getItem(OVERRIDE_ID_FB_PAGE)){
            overrideAccount['fbPage'] = true
        }
    
        if(sessionStorage.getItem(OVERRIDE_ID_LINKEDIN)){
            overrideAccount['linkedin'] = true
        }
        if(sessionStorage.getItem(OVERRIDE_ID_LINKEDIN_ORG)){
            overrideAccount['linkedinOrg'] = true
        }
    
        if(sessionStorage.getItem(OVERRIDE_ID_BING)){
            overrideAccount['bing'] = true
        }
    
        if(sessionStorage.getItem(OVERRIDE_ID_GSC)){
            overrideAccount['gsc'] = true
        }
      
        Object.keys(overrideAccount).forEach(key => {
            if(overrideAccount[key] && DateTime.local().toMillis() >= parseInt(sessionStorage.getItem(key))) {
                sessionStorage.removeItem(`overrideAccount${key}`)
            }
        })

        setOverrideAccounts(overrideAccount)
    }, [])

    const checkAcctOverrides = () => {
        let sForm = {
            ...model.siteForm
        }
        if(sessionStorage.getItem(OVERRIDE_ID_GA)){
            const gaAcctFound = oauthTokens.ga?.accounts.reduce((prev, ga) => {
              if(ga.webProperties){
                let profiles = ga.webProperties.map(prop => prop.profiles).flat()
                if(profiles !== null && profiles.find(prof => prof !== null && prof.id === sForm?.attr?.accounts?.ga?.viewId)){
                  prev = true
                }
              }

              if(ga.propertySummaries){
                  let properties = ga.propertySummaries
                  if(properties !== null && properties.find(p => p !== null && p.property === sForm?.attr?.accounts?.ga?.propertyId)){
                    prev = true
                  }
              }
      
              return prev
            }, false)
      
            if(!gaAcctFound){
              toast.error("Google Analytics token reset is not successful because the chosen GA account does not have the permission to access this particular view. Please contact the system's administrator for more information", {
                autoClose:false,
                closeOnClick: true
              })
              
              dispatch(deleteMetricSessionStorage())
              return sForm
            }
      
            if(sForm?.attr.accounts
            && sForm?.attr.accounts.ga
            && sForm?.attr.accounts.ga.refreshRequired){
                sForm = {
                    ...model.siteForm,
                    attr: {
                        ...sForm.attr,
                        accounts: {
                            ...(sForm.attr?.accounts ?? {}),
                            ga: {
                                ...(sForm.attr?.accounts?.ga ?? {}),
                                tokenId: oauthTokens.ga?.id,
                                refreshRequired: undefined,
                                refreshAlertDate: undefined
                            }
                        }
                    }
                }
            }
        }
        if(sessionStorage.getItem(OVERRIDE_ID_GMB)){ 
            const locId = sForm?.attr?.accounts?.gmb?.locationId.split("/")
            const gmbAcctFound = oauthTokens.gmb?.accounts?.reduce((prev, gmb) => {
              if(gmb.locations){
                const location = locId?.length > 0 ? gmb.locations.find(location => location !== null && location?.name ? location.name.includes(locId[locId.length - 1]) : null) : null
                if(location){
                  prev = {location, id: gmb.name, name: gmb.accountName}
                }
              }
      
              return prev
            }, false)
      
            if(!gmbAcctFound){
              toast.error("Google Business Profile token reset is not successful because the chosen GBP account does not have the permission to access this particular location. Please contact the system's administrator for more information", {
                autoClose:false,
                closeOnClick: true
              })
              
              dispatch(deleteMetricSessionStorage())
              return sForm
            }
      
            if(sForm.attr?.accounts?.gmb?.refreshRequired){
                sForm = {
                    ...model.siteForm,
                    attr: {
                        ...sForm.attr,
                        accounts: {
                            ...(sForm.attr?.accounts ?? {}),
                            gmb: {
                                ...(sForm.attr?.accounts?.gmb ?? {}),
                                tokenId: oauthTokens.gmb?.id,
                                locationId: gmbAcctFound.id + "/" + gmbAcctFound.location.name,
                                locationName: gmbAcctFound.location.title,
                                accountId: gmbAcctFound.id,
                                accountName: gmbAcctFound.name,
                                refreshRequired: undefined,
                                refreshAlertDate: undefined
                            }
                        }
                    }
                }
            }
        }
        if(sessionStorage.getItem(OVERRIDE_ID_FB)){
            if(sForm?.attr?.accounts?.fb?.refreshRequired){
                sForm = {
                    ...model.siteForm,
                    attr: {
                        ...sForm.attr,
                        accounts: {
                            ...(sForm.attr?.accounts ?? {}),
                            fb: {
                                ...(sForm.attr?.accounts?.fb ?? {}),
                                refreshRequired: undefined,
                                refreshAlertDate: undefined
                            }
                        }
                    }
                }
            }
        }
        if(sessionStorage.getItem(OVERRIDE_ID_FB_PAGE)){
            if(sForm?.attr?.accounts?.fbPage?.refreshRequired){
                sForm = {
                    ...model.siteForm,
                    attr: {
                        ...sForm.attr,
                        accounts: {
                            ...(sForm.attr?.accounts ?? {}),
                            fbPage: {
                                ...(sForm.attr?.accounts?.fbPage ?? {}),
                                refreshRequired: undefined,
                                refreshAlertDate: undefined
                            }
                        }
                    }
                }
            }
        }

        if(sessionStorage.getItem(OVERRIDE_ID_BING) && sForm.attr?.accounts?.bing?.refreshRequired){
            sForm = {
                ...model.siteForm,
                attr: {
                    ...sForm.attr,
                    accounts: {
                        ...(sForm.attr?.accounts ?? {}),
                        bing: {
                            ...(sForm.attr?.accounts?.bing ?? {}),
                            refreshRequired: undefined,
                            refreshAlertDate: undefined
                        }
                    }
                }
            }
        }

        if (sessionStorage.getItem(OVERRIDE_ID_LINKEDIN) && 
            sForm.attr?.accounts?.linkedin?.refreshRequired){
            sForm = {
                ...model.siteForm,
                attr: {
                    ...sForm.attr,
                    accounts: {
                        ...(sForm.attr?.accounts ?? {}),
                        linkedin: {
                            ...(sForm.attr?.accounts?.linkedin ?? {}),
                            refreshRequired: undefined,
                            refreshAlertDate: undefined
                        }
                    }
                }
            }
        }

        if (sessionStorage.getItem(OVERRIDE_ID_LINKEDIN_ORG) && 
            sForm.attr?.accounts?.linkedinOrg?.refreshRequired){

            const orgUrn = sForm?.attr?.accounts?.linkedinOrg?.urn
            const liAcctFound = oauthTokens.linkedinOrg?.accounts?.reduce((prev, li) => {
                if(li.urn === orgUrn){
                    prev = li
                }
        
                return prev
            }, false)

            if(!liAcctFound){
                toast.error("LinkedIn Organization token reset is not successful because the chosen LinkedIn Org account does not have the permission to access this particular account. Please contact the system's administrator for more information", {
                    autoClose:false,
                    closeOnClick: true
                })
                
                dispatch(deleteMetricSessionStorage())
                return sForm
            }

            sForm = {
                ...model.siteForm,
                attr: {
                    ...sForm.attr,
                    accounts: {
                        ...(sForm.attr?.accounts ?? {}),
                        linkedinOrg: {
                            ...(sForm.attr?.accounts?.linkedinOrg ?? {}),
                            refreshRequired: undefined,
                            refreshAlertDate: undefined
                        }
                    }
                }
            }
        }
        if(sessionStorage.getItem(OVERRIDE_ID_GSC)){
            if(sForm?.attr?.accounts?.fb?.refreshRequired){
                sForm = {
                    ...model.siteForm,
                    attr: {
                        ...sForm.attr,
                        accounts: {
                            ...(sForm.attr?.accounts ?? {}),
                            gsc: {
                                ...(sForm.attr?.accounts?.gsc ?? {}),
                                refreshRequired: undefined,
                                refreshAlertDate: undefined
                            }
                        }
                    }
                }
            }
        }

        return sForm
    }

    const onSave = async() => {
        const sForm = checkAcctOverrides()
        const body = {
            site: {...sForm}
        }

        if(!disableGA4Override){
            if(Object.keys(overrideAccounts).length > 0){
                let oAccts = {...overrideAccounts}

                if(oAccts.ga4){
                    oAccts.ga4 = isAdmin ? ga4MetricDateOverride : true
                }

                body.overrideAccounts = oAccts
            }
        }
        
        const { response, error } = await updateSite(sForm.siteId, token, body)

        let sites = [...model.sites]

        sites[model.siteActiveIdx] = sForm

        let all = [...model.all]

        const allIdx = all.findIndex(a => a.siteId === sForm.siteId)

        if(allIdx){
            all[allIdx] = sForm
        }

        dispatch(appendModel({
            all,
            sites,
            siteForm: sForm
        }))

        dispatch(deleteMetricSessionStorage())
        
        localStorage.removeItem("gaSelection")
        localStorage.removeItem("ga4Selection")
        localStorage.removeItem("gmbSelection")
        localStorage.removeItem("fbSelection")
        localStorage.removeItem("fbPageSelection")
        localStorage.removeItem("bingSelection")
        localStorage.removeItem("linkedinSelection")
        localStorage.removeItem("linkedinOrgSelection")
        localStorage.removeItem("gscSelection")
    }

    const deleteService = async(service) => {
        const result = window.confirm("Are you sure you want to delete this account?")
    
        if(result){ 
            const { error } = await deleteSiteService(model.siteForm.siteId, service)
            if(error){
                toast.error("Something went wrong", {containerId: "defaultToastContainer"})
            } else {
                toast.success("Account deleted", {containerId: "defaultToastContainer"})

                let sForm = {
                    ...model.siteForm,
                    attr: {
                        ...model.siteForm.attr,
                        accounts: {
                            ...(model.siteForm.attr?.accounts ?? {}),
                            [service]: undefined
                        }
                    }
                }
                let stes = [...model.sites]
                stes[model.siteActiveIdx] = sForm

                let all = [...model.all]

                let allIdx = all.find(a => a.siteId === sForm.siteId)
                if(allIdx){
                    all[allIdx] = sForm
                }

                dispatch(appendModel({
                    siteForm: sForm,
                    sites: stes,
                    all
                }))
            }
        }
    }

    const resetToken = (service, oauthLink, ga4Override=false) => {
        if(model.siteForm?.attr?.accounts[service]){
            sessionStorage.setItem(`overrideAccount${ga4Override ? "ga4" :service}`, DateTime.local().plus({ hours: 1 }).toMillis())
            window.location.href = oauthLink
        }
    }

    const site = model.sites[model.siteActiveIdx]

    const sMap = [
        ...Object.values(serviceMap)
        // .filter(s => s.key === chosenService.key),
        // ...Object.values(serviceMap).filter(s => s.key !== chosenService.key)
    ]

    return <>
        <h3>Services</h3><br />
        {(!model.reseller || (model.reseller && !model.isAffiliate)) && <div className="d-flex justify-content-end mb-3">
            <div className="btn-group">
                <button className={`btn btn-lg btn-primary ${pulse ? "pulse-blue":""}`} onClick={() => onSave()} id="saveSiteBtn">
                    <i class="fas fa-save"></i> Save
                </button>
                <Tooltip placement="left" isOpen={pulse} toggle={() => setPulse(!pulse)} target="saveSiteBtn">
                    Click here to save your changes below
                </Tooltip>
            </div>
        </div>}

        <Carousel className={"h-120px translate-custom mb-3"} infinite={false} dynamic={true} show={3.5} slide={3} swiping={true} leftArrow={<>
            <i class="fas fa-3x fa-chevron-left mt-4 mr-2 d-none d-sm-block"></i>
            <i class="fas fa-2x fa-chevron-left mt-4 mr-2 d-block d-sm-none"></i>
        </>} rightArrow={<>
            <i class="fas fa-3x fa-chevron-right mt-4 ml-2 d-none d-sm-block"></i>
            <i class="fas fa-2x fa-chevron-right mt-4 ml-2 d-block d-sm-none"></i>
        </>}>
            {sMap.map(service => (<ServiceCard 
                className={"mr-2"} 
                refreshRequired={site?.attr?.accounts && site?.attr?.accounts[service.key] && site?.attr?.accounts[service.key].refreshRequired}
                claimed={site?.attr?.accounts && site?.attr?.accounts[service.key]}
                active={service.key === chosenService.key} {...service} site={site}
                enableTransition={false} 
                onChosen={() => setChosenService(service)}
                overrideIcon={service.key === "gmb" && 
                    ["FAILED", "NOT_FOUND"].includes(site?.attr?.accounts?.gmb?.verificationStatus) ? 
                    <i className={`fas fa-exclamation-circle text-warning fa-1-5`}></i> : 
                    service.key === "ga" && site?.attr?.accounts?.ga?.tokenId && !site?.attr?.accounts?.ga?.tokenId.includes("ga4:") ?
                    <i class="fas fa-sync-alt text-info fa-1-5"></i> :
                    null}                
            />))}
        </Carousel>

        {chosenService?.component ? <chosenService.component 
            onDeleteService={service => deleteService(service)} 
            onResetToken={resetToken}
            onSelectionUpdated={(service) => {
                setPulse(true)
            }}
        /> : <></> }
    </>
}

export default Base